<template>
    <section>
        <div>
            <the-header></the-header>
        </div>

        <div class="pt-32 md:pt-20 flex justify-center md:flex-col p-6">
            <div class="w-1/3 mt-10 md:w-full md:p-2 mr-6">
               <div>
                <p class=" font-medium mb-4 text-xl">Contact Information</p>
                <div>
                    <p>
                        <i class="fa fa-phone fa-2x text-blue-800 mr-4"></i>
                        <a href="tel:09125258272" >09125258272</a>,  
                        <span><a href="tel: 0912 407 5102">09124075102 </a></span>  
                    </p>
                    

                    <div class=" mt-4 flex">
                            <a href="https://instagram.com/carrygo_ng?utm_medium=copy_link"><i class=" fa fa-instagram fa-2x text-blue-800"></i></a>
                            <p class="ml-2"> @carrygo_ng</p>
                    </div>
                    <div class=" mt-4 flex">
                        <a href="https://twitter.com/_CarryGoNg?t=hr9WEcQiMa56dd8G6ilY-g&s=09"><i class="mr-2 fa fa-twitter fa-2x text-blue-800"></i></a>
                        <p> @_CarryGoNg</p>
                    </div>
                    <p class=" mt-4">
                            <i  class=" fa fa-envelope fa-2x text-blue-800 mr-2"></i>
                        <a 
                        href="mailto:suppport@carrygo.me">info@carrygo.me
                            </a> 
                    </p>

                    <div class=" mt-4">
                            <i  class=" fa fa-home fa-2x text-blue-800 mr-4"></i>
                         <p>15, Ihuntayi Road, Oniru Palace, Victoria Island</p>
                    </div>
                </div>
            </div>

            </div>

            <div class=" w-1/3 mt-10 md:w-full md:p-2 pb-20 md:pb-6">
                <div >
                    <form @submit.prevent="sendMessage">
                        <div class=" mt-2">
                            <label for="name">Name</label><br>
                            <input class="border outline-none mt-1 w-full p-1 rounded-lg border-blue-600" type="text" name="name" id="name" v-model="name">
                            <p class=" text-sm text-red-600" v-if="nameValidity === 'invalid'">this field cannot be empty</p>
                        </div>

                        <div class=" mt-2">
                            <label for="Email Address">Email Address</label><br>
                            <input class="border outline-none mt-1 w-full p-1 rounded-lg border-blue-800" type="text" name="email" id="email" v-model="email">
                            <p class=" text-sm text-red-600" v-if="emailValidity === 'invalid'">this field cannot be empty</p>
                        </div>

                        <div class="mt-2">
                            <label for="subject">Subject</label><br>
                            <input class="border outline-none mt-1 w-full p-1 rounded-lg border-blue-800" type="text" name="subject" id="subject" v-model="subject">
                            <p class=" text-sm text-red-600" v-if="subjectValidity === 'invalid'">this field cannot be empty</p>

                        </div>

                        <div class="mt-2">
                            <label for="message">Write your message</label><br>
                            <textarea rows="8"
                                class="border outline-none mt-1 w-full p-1 rounded-lg border-blue-800" type="text" name="message" id="message" v-model="theMessage">
                            </textarea>
                            <p class=" text-sm text-red-600" v-if="messageValidity === 'invalid'">this field cannot be empty</p>

                        </div>

                        <div class=" mt-2 flex">
                            <button class=" w-1/2 m-auto bg-blue-800 p-2 text-white  rounded-lg  ">Send Message </button>
                            <p v-if="isLoading" class="ml-2 mt-2 animate-spin rounded-full h-6 w-6 border border-t-2 border-b-2 border-blue-900 "></p>
                        </div>
                    </form>
                </div>
            </div>

        </div>


        <TheFooter/>
        <SuccessfulModal
        v-show="isModalVisible"
        @click="close"
        :message="message"
        />
    </section>
</template>

<script>
import TheHeader from '../layout/TheHeader.vue';
import TheFooter from '../layout/TheFooter.vue';
import {baseUrl} from '../../Config';
const url = baseUrl;
import axios from 'axios';
import SuccessfulModal from './SuccessfulModal.vue'
export default {
    components: {
        TheHeader,
        TheFooter,
        SuccessfulModal
    },

    data() {
        return {
            name: '',
            email: '',
            subject: '',
            theMessage: '',

            emailValidity : '',
            nameValidity: '',
            subjectValidity: '',
            messageValidity: '',
            isLoading: false,
            isModalVisible: false,
            message: ""
            
        }
    },

    methods: {
        close() {
            this.isModalVisible = false
        },
        sendMessage() {
            if(!this.name) {
                this.nameValidity = 'invalid'
            } else if (!this.email) {
                this.emailValidity = 'invalid'
            } else if (!this.subject) {
                this.subjectValidity = 'invalid'
            } else if (!this.theMessage) {
                this.messageValidity = 'invalid'
            } else {
                this.isLoading = true;
                axios({
                    method: "POST",
                    url: `${url}/v1/web/extras/feedback`,
                    headers: {
                        'Content-type': 'application/json',
                        'cg-key':  '7C99A10492E73F0A6B8F64029386A24DE7FAA2FC5EBFE8948242F423CADA3'
                    },
                    data : {
                        name: this.name,
                        email: this.email,
                        subject: this.subject,
                        message: this.theMessage
                    }
                })
                .then((response) => {
                    this.isLoading = false;
                    console.log(response);
                    this.isModalVisible = true;
                    this.message = "Thanks " + this.name + ", your message has been sent."
                    this.name = '',
                    this.email = '',
                    this.subject = '',
                    this.theMessage = ''
                })
                .catch((error) => {
                    this.isModalVisible = true;
                    this.message = "Ooops something went wrong"
                    this.isLoading = false;
                    error;
                })
            }
        }
    }
    
}
</script>